export function isInputField(field) {
  return Boolean(field.target);
}
//# sourceMappingURL=form-view.js.map